import { useState, useEffect } from "react";
import styles from "./testimonial.module.css";
import { testimonials } from "../../constants/testimonial-data";
import TestimonialCard from "./TestimonialCard/TestimonialCard";

const Testimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);
  const total = testimonials.length;
  // Adjust visibleCount based on screen width
  useEffect(() => {
    const updateVisibleCount = () => {
      const width = window.innerWidth;
      if (width >= 1200) setVisibleCount(4);
      else if (width >= 992) setVisibleCount(3);
      else if (width >= 768) setVisibleCount(2);
      else setVisibleCount(1);
    };
    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);
    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + total) % total);
  };
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % total);
  };
  // Build visible cards with looping
  const visibleTestimonials = [];
  for (let i = 0; i < visibleCount; i++) {
    visibleTestimonials.push(testimonials[(currentIndex + i) % total]);
  }
  return (
    <section className={styles.testimonial__wrapper}>
      <h2 className={styles.heading}>Customer Reviews</h2>
      <p className={styles.subhead}>Our References Are Very Valuable , The Result Of A Great Effort....</p>
      <div className={styles.testimonial__container}>
        <button className={`${styles.arrow} ${styles.left}`} onClick={handlePrev}>
          &#10094;
        </button>
        <div className={styles.cards}>
          {visibleTestimonials.map((testimonial, idx) => (
            <TestimonialCard key={idx} testimonial={testimonial} />
          ))}
        </div>
        <button className={`${styles.arrow} ${styles.right}`} onClick={handleNext}>
          &#10095;
        </button>
      </div>
      {/* DOTS */}
      <div className={styles.dots}>
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`${styles.dot} ${index === currentIndex ? styles.active : ""}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </section>
  );
};
export default Testimonial; 